import {React, useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { DataGrid, GridToolbar, frFR  } from '@mui/x-data-grid';
import Cookies from 'js-cookie'

import { useSelector ,useDispatch} from 'react-redux'
import {  useNavigate  } from "react-router-dom";
import { useCookies } from 'react-cookie';

import Autorize from '../ui/autorize';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
export default  function RapportAnnuel({clubid,secteur,annee}) {

    const [listClub, setListClub] = useState("");   
    const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState("false");

    const [total, setTotal] = useState("0");
           
  
  /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
    headers: { Authorization: "Bearer "+ Cookies.get('token'),
            }      
})
    
    useEffect(() => { 
                  
             //alert("fdfsdfds");
            //, { headers: { Authorization: "Bearer "+ cookies }}
           console.log("LstMembreAnnee");
            if(autorize)
            {

                if(annee === undefined)
                    annee = "2023";

            MyAxios.get(process.env.REACT_APP_API + '/rapports/getReportCompletAnneeEffectif/'+ secteur + "/" + annee + "/" + clubid) //axios.defaults.withCredentials = true
            .then((res) => {      
                setErrorAxios(false);
                console.log(res);
                setListClub(res.data);
               
            })
            .catch((error) => {
                console.log(error)  
              ///  if(error.status)  
               //if(error.response.status === 401)// pas autorisé
                 setErrorAxios(true);   

            });
        }
       
    },[secteur,annee,clubid,autorize]);
   
        

        const columns = [           
            {      field: 'id',            headerName: 'id' ,        width: 0 ,     hide: true}  ,
            {      field: 'ClubNumber',      headerName: '# de club' ,    width: 100 ,    }  ,
            {      field: 'ClubName',      headerName: 'Nom du club' ,    width: 300 ,    }  ,         
            {      field: 'octobre',     headerName: 'Octobre' ,  width: 160 ,     }  ,
            {      field: 'DebutMois',     headerName: 'Debut Mois' ,    width: 160 ,   }  ,               
            {      field: 'Maintenant',        headerName: 'Maintenant' ,    width: 160 ,      }  ,
            {      field: 'AddThisMonth',        headerName: '+ (à ce jour)' ,   width: 160 ,       }  ,
            {      field: 'RemoveThisMonth',        headerName: '- (à ce jour)' ,   width: 160 ,       }  ,  
            {      field: 'Net_Mois',        headerName: 'Net (à ce jour)' ,   width: 160 ,       }  ,
            {      field: 'AddThisYear',        headerName: '+ (début année)' ,   width: 160 ,       }  ,
            {      field: 'DeleteThisYear',        headerName: '- (début année)' ,   width: 160 ,       }  ,
            {      field: 'Net_Annee',        headerName: 'Net (début année)' ,   width: 160 ,       }  ,            
            {      field: 'Life_Member',        headerName: 'Mnr vie' ,   width: 160 ,       }  ,
            {      field: 'Charter_Member',        headerName: 'Mbr fondateur' ,   width: 160 ,       }  ,
            {      field: 'CollegeMbr',        headerName: 'Mbr colleg/univ' ,   width: 160 ,       }  ,         
          
        ];

//  {JSON.stringify(this.state.currentMember, null, 2) }     {Table}


  const callbackAutoriser = (index) => { // the callback. Use a better name      
    setAutorize(index);     
  };

  
        return (
                <div >
                    <Autorize  axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>
                     
                    <div style={{ height: 300 }}>
                        <DataGrid key="DataGridMember" localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                                    rows={listClub}
                                    columns={columns}
                                    pageSize={100}
                                    rowsPerPageOptions={[100]}                               
                                    components={{ Toolbar: GridToolbar }} 
                                    initialState={{
                                        filter: {
                                        filterModel: {
                                            items: [{ columnField: 'Status', operatorValue: 'equals', value: 'Actif' }],
                                        },
                                        },
                                    }}
                                    
                                />

                           
                    </div>
                   

                </div>
       
        );
   
};

